const RecommendersInfoConfirm = ({fields, viewMode, member}) => {

  return (
    <>
              <h3>推薦者 （正会員1名）</h3>
              <dl>
                <dt>推薦者</dt>
          <dd>{(viewMode ? member.recommender : fields.recommender) ? (viewMode ? member.recommender : fields.recommender) : ''}&nbsp;</dd>
                <dt>推薦理由</dt>
          <dd>{(viewMode ? member.reasonForRecommend : fields.reasonForRecommend) ? (viewMode ? member.reasonForRecommend : fields.reasonForRecommend) : ''}&nbsp;</dd>
                </dl>
    </>
  );
}

export default RecommendersInfoConfirm;
